
{
  "familyId": "MET-COORDINATEN",
  "questions": [
    {
      "id": "MET-COORDINATEN-001",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "multiple_choice",
      "question": "Een cartograaf plaatst punten op een kaart. Welk punt heeft de coördinaten (3, 5)?",
      "context": "In een assenstelsel staan vier punten: A = (3, 5), B = (5, 3), C = (3, 3), D = (5, 5).",
      "options": ["Punt A", "Punt B", "Punt C", "Punt D"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 7,
            "height": 7,
            "showGrid": true,
            "points": [
              { "x": 3, "y": 5, "label": "A" },
              { "x": 5, "y": 3, "label": "B" },
              { "x": 3, "y": 3, "label": "C" },
              { "x": 5, "y": 5, "label": "D" }
            ],
            "label": "Assenstelsel met punten A, B, C, D"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Coördinaten lezen",
            "content": "Bij coördinaten (x, y) ga je eerst naar rechts (x-as) en dan omhoog (y-as). (3, 5) = 3 naar rechts, 5 omhoog.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "coordinates_identify_point",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Bij coördinaten (x, y) ga je eerst langs de x-as (horizontaal) en dan langs de y-as (verticaal). x = 3 → ga 3 naar rechts. y = 5 → ga 5 omhoog. Dat is punt A. Onthoud: eerst de x (naar rechts), dan de y (omhoog).",
        "solutionSteps": [
          "x = 3 → ga 3 naar rechts",
          "y = 5 → ga 5 omhoog",
          "Dat is punt A"
        ],
        "distractorExplanations": {
          "0": "Goed! (3, 5) = 3 naar rechts, 5 omhoog = punt A.",
          "1": "Je dacht waarschijnlijk dat x en y omgedraaid zijn. Maar punt B = (5, 3), niet (3, 5). Onthoud: bij (3, 5) ga je eerst 3 naar rechts, dan 5 omhoog.",
          "2": "Je dacht waarschijnlijk dat de y-coördinaat 3 is. Maar punt C = (3, 3), terwijl (3, 5) een y van 5 heeft. Onthoud: het tweede getal is de y-coördinaat.",
          "3": "Je dacht waarschijnlijk dat de x-coördinaat 5 is. Maar punt D = (5, 5), terwijl (3, 5) een x van 3 heeft. Onthoud: het eerste getal is de x-coördinaat."
        }
      }
    },
    {
      "id": "MET-COORDINATEN-002",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "multiple_choice",
      "question": "Een game-ontwerper plaatst punt P op (4, 2). Punt Q staat 3 hokjes naar rechts en 1 hokje omhoog. Wat zijn de coördinaten van Q?",
      "context": null,
      "options": ["(7, 3)", "(1, 1)", "(4, 5)", "(7, 2)"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 9,
            "height": 6,
            "showGrid": true,
            "points": [{ "x": 4, "y": 2, "label": "P" }],
            "label": "Assenstelsel met punt P"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Coördinaten verschuiven",
            "content": "Naar rechts = x wordt groter. Omhoog = y wordt groter. P = (4, 2). 3 naar rechts: x = 4 + 3 = 7. 1 omhoog: y = 2 + 1 = 3.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "coordinates_translate",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Tel de verschuiving op bij de coördinaten. P = (4, 2). 3 naar rechts → x = 4 + 3 = 7. 1 omhoog → y = 2 + 1 = 3. Q = (7, 3). Onthoud: naar rechts = x groter, omhoog = y groter.",
        "solutionSteps": [
          "P = (4, 2)",
          "3 naar rechts: x = 4 + 3 = 7",
          "1 omhoog: y = 2 + 1 = 3",
          "Q = (7, 3)"
        ],
        "distractorExplanations": {
          "0": "Goed! (4+3, 2+1) = (7, 3).",
          "1": "Je dacht waarschijnlijk dat je moet aftrekken. Maar naar rechts = x groter, omhoog = y groter. Onthoud: (4−3, 2−1) = (1, 1) is naar links en omlaag.",
          "2": "Je dacht waarschijnlijk dat je alleen de y-coördinaat verandert. Maar de x moet ook veranderen: 4 + 3 = 7. Onthoud: 3 naar rechts verandert de x-coördinaat.",
          "3": "Je dacht waarschijnlijk dat je vergeet omhoog te gaan. Maar y = 2 + 1 = 3, niet 2. Onthoud: 1 omhoog verandert de y-coördinaat."
        }
      }
    },
    {
      "id": "MET-COORDINATEN-003",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "multiple_choice",
      "question": "Welke coördinaten horen bij de oorsprong van het assenstelsel?",
      "context": null,
      "options": ["(0, 0)", "(1, 1)", "(0, 1)", "(1, 0)"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 5,
            "height": 5,
            "showGrid": true,
            "points": [{ "x": 0, "y": 0, "label": "O" }],
            "label": "Assenstelsel met oorsprong O"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oorsprong",
            "content": "De oorsprong is het punt waar de x-as en y-as elkaar kruisen. Dat is altijd (0, 0) — nul naar rechts, nul omhoog.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "coordinates_origin",
      "variantIndex": 3,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "De oorsprong is het snijpunt van de x-as en y-as. Beide assen beginnen bij 0, dus de oorsprong = (0, 0). Onthoud: oorsprong = startpunt = (0, 0).",
        "solutionSteps": [
          "De oorsprong is waar de x-as en y-as kruisen",
          "x = 0 en y = 0",
          "Oorsprong = (0, 0)"
        ],
        "distractorExplanations": {
          "0": "Goed! De oorsprong = (0, 0).",
          "1": "Je dacht waarschijnlijk dat het assenstelsel bij (1, 1) begint. Maar (1, 1) is het eerste punt rechts en boven de oorsprong. Onthoud: de oorsprong is altijd (0, 0).",
          "2": "Je dacht waarschijnlijk dat (0, 1) de oorsprong is. Maar (0, 1) is 1 omhoog op de y-as. Onthoud: bij de oorsprong zijn beide coördinaten 0.",
          "3": "Je dacht waarschijnlijk dat (1, 0) de oorsprong is. Maar (1, 0) is 1 naar rechts op de x-as. Onthoud: bij de oorsprong zijn beide coördinaten 0."
        }
      }
    },
    {
      "id": "MET-COORDINATEN-004",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "multiple_choice",
      "question": "Een architect tekent een rechthoek. Drie hoekpunten zijn: (1, 1), (1, 4), (6, 1). Wat is het vierde hoekpunt?",
      "context": null,
      "options": ["(6, 4)", "(4, 6)", "(6, 6)", "(4, 4)"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 8,
            "height": 6,
            "showGrid": true,
            "points": [
              { "x": 1, "y": 1, "label": "A" },
              { "x": 1, "y": 4, "label": "B" },
              { "x": 6, "y": 1, "label": "C" },
              { "x": 6, "y": 4, "label": "?" }
            ],
            "label": "Rechthoek met 3 hoekpunten"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vierde hoekpunt vinden",
            "content": "Een rechthoek heeft tegenoverliggende zijden die gelijk zijn. Het vierde punt deelt coördinaten met twee andere punten: dezelfde x als C (6) en dezelfde y als B (4).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "coordinates_rectangle_vertex",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het vierde hoekpunt deelt coördinaten met twee andere punten. Punt C heeft x = 6, punt B heeft y = 4. Het vierde punt = (6, 4). Controleer: A(1,1), B(1,4), C(6,1), D(6,4) vormen een rechthoek ✓.",
        "solutionSteps": [
          "Punt C heeft x = 6",
          "Punt B heeft y = 4",
          "Vierde punt = (6, 4)",
          "Controleer: vormt een rechthoek ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Het vierde hoekpunt is (6, 4).",
          "1": "Je dacht waarschijnlijk dat x en y omgedraaid zijn. Maar het moet (6, 4) zijn, niet (4, 6). Onthoud: x komt van punt C (6), y komt van punt B (4).",
          "2": "Je dacht waarschijnlijk dat de y-coördinaat 6 is. Maar de y moet gelijk zijn aan punt B: y = 4, niet 6. Onthoud: het vierde punt deelt coördinaten met twee andere punten.",
          "3": "Je dacht waarschijnlijk dat de x-coördinaat 4 is. Maar de x moet gelijk zijn aan punt C: x = 6, niet 4. Onthoud: kijk welke x en y al voorkomen bij de andere punten."
        }
      }
    },
    {
      "id": "MET-COORDINATEN-005",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "multiple_choice",
      "question": "Een landmeter meet de afstand tussen punt A (2, 3) en punt B (2, 8). Hoe groot is de afstand?",
      "context": null,
      "options": ["5", "6", "10", "3"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 6,
            "height": 10,
            "showGrid": true,
            "points": [
              { "x": 2, "y": 3, "label": "A" },
              { "x": 2, "y": 8, "label": "B" }
            ],
            "label": "Punten A en B op dezelfde verticale lijn"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afstand op één as",
            "content": "Als twee punten dezelfde x-coördinaat hebben, staan ze op dezelfde verticale lijn. De afstand is dan het verschil van de y-coördinaten: |8 − 3| = 5.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "coordinates_distance_vertical",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Als punten op dezelfde verticale lijn staan (zelfde x), is de afstand het verschil in y. A = (2, 3), B = (2, 8). Zelfde x (2), dus afstand = |8 − 3| = 5. Onthoud: zelfde x → verticale afstand = verschil in y.",
        "solutionSteps": [
          "A = (2, 3), B = (2, 8)",
          "Zelfde x-coördinaat (2) → verticale lijn",
          "Afstand = |8 − 3| = 5"
        ],
        "distractorExplanations": {
          "0": "Goed! |8 − 3| = 5 eenheden.",
          "1": "Je dacht waarschijnlijk dat de afstand 6 is. Maar het verschil is 8 − 3 = 5, niet 6. Onthoud: trek de y-coördinaten van elkaar af.",
          "2": "Je dacht waarschijnlijk dat je de coördinaten optelt. Maar afstand = verschil, niet som. 8 − 3 = 5. Onthoud: afstand = aftrekken.",
          "3": "Je dacht waarschijnlijk dat 3 de afstand is. Maar 3 is de y-coördinaat van punt A, niet de afstand. Onthoud: afstand = |8 − 3| = 5."
        }
      }
    },
    {
      "id": "MET-COORDINATEN-006",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "fill_in",
      "question": "Een tuinontwerper plaatst een boom op punt (5, 2). Die boom schuift 4 hokjes naar rechts. Wat is de nieuwe x-coördinaat? Typ het getal.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["9"],
        "caseSensitive": false,
        "placeholder": "x = ..."
      },
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 11,
            "height": 5,
            "showGrid": true,
            "points": [{ "x": 5, "y": 2, "label": "boom" }],
            "label": "Assenstelsel met boom op (5, 2)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verschuiving op de x-as",
            "content": "Naar rechts schuiven = x wordt groter. De boom staat op x = 5. 4 naar rechts: x = 5 + 4 = 9. De y-coördinaat verandert niet (blijft 2).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "coordinates_translate_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Naar rechts schuiven betekent dat de x-coördinaat groter wordt. De boom staat op (5, 2). 4 naar rechts: x = 5 + 4 = 9. De y-coördinaat verandert niet. Onthoud: naar rechts = x groter, de y blijft gelijk.",
        "solutionSteps": [
          "De boom staat op x = 5",
          "4 naar rechts: x = 5 + 4 = 9",
          "De y-coördinaat verandert niet (blijft 2)",
          "Nieuwe positie: (9, 2)"
        ]
      }
    }
  ]
}
